/**
 * Usage:
 *
 * Step 1: Somewhere in JS...
 *   import Alpine from "alpinejs";
 *   import spine from "./headroom";
 *   Alpine.data('headroom', headroom);
 *   Alpine.start();
 *
 * Step 2: Somewhere in markup...
 *   <header x-data="headroom()" />
 *
 * @param selector
 * @returns {{init(): void, el: null, selector: null}}
 */

import Headroom from "headroom.js";

export default () => ({
  pinned: true,
  isAtTop: true,
  
  init() {
    const headroom = new Headroom(this.$el, {
      tolerance: {
        up: 0,
        down: 10,
      },
      offset: {
        up: 0,
        down: 20,
      },
      onPin: () => {
        this.pinned = true;
      },
      onUnpin: () => {
        this.pinned = false;
      },
      onTop: () => {
        this.isAtTop = true;
      },
      onNotTop: () => {
        this.isAtTop = false;
      },
    });
    headroom.init();
  },
});
